import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { ManagementRoutingModule } from './management.routing';
import { RouterModule } from '@angular/router';
import { UsersComponent } from './users/users.component';
import { ManagementLayoutComponent } from './management-layout/management-layout.component';
import { HeaderSearchComponent } from './header-search/header-search.component';
import { ButtonComponent } from '../business-loan/button/button.component';
import { DialogModule } from '../dialog/dialog.module';

@NgModule({
    declarations: [UsersComponent, ManagementLayoutComponent, HeaderSearchComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        ManagementRoutingModule,
        RouterModule,
        ButtonComponent,
        DialogModule,
    ]
})
export class ManagementModule { }
